import { Box } from "@mui/material";
import { OssMetricCards } from "../common/OssMetricCards";

export const OssDashboardKpiBoard = ({ items, activeKey, onItemClick }) => (
  <Box sx={{ flexShrink: 0, "& .oss-metric": { borderTop: "3px solid var(--metric-tone)", py: 1.75, px: { xs: 2, lg: 2.5 } } }}>
    <OssMetricCards columns={{ xs: 2, md: 3, lg: 6 }} activeKey={activeKey} onItemClick={onItemClick}
      items={items.map((item) => ({ ...item, filterKey: item.key, tone: item.color, unit: "건" }))} />
  </Box>
);
